import { Plan } from '../../../../types';

export const tabFieldsMap: { [key: string]: Array<keyof Plan> } = {
  general: ['title', 'kind', 'activities', 'beginning', 'end'],
};
